import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RequireSignedIn } from "@/components/auth/RequireSignedIn";
import { Sidebar } from "@/components/common/sidebar";
import { RequireOrganization } from "@/components/organization/RequireOrganization";

export const Route = createFileRoute("/_layout")({
  component: StandardLayout,
});

function StandardLayout() {
  return (
    <RequireSignedIn>
      <RequireOrganization>
        <div className="dashboard-shell">
          <Sidebar />
          <main className="min-w-0 flex-1">
            <Outlet />
          </main>
        </div>
      </RequireOrganization>
    </RequireSignedIn>
  );
}
